module.exports = __webpack_public_path__ + "img/flower-red.8714dacc.png";